export const chartPalette = {
  primary: "#4F46E5",
  primarySoft: "#818CF8",
  success: "#10B981",
  warning: "#F59E0B",
  danger: "#EF4444",
  info: "#0EA5E9",
  purple: "#A855F7",
  pink: "#EC4899",
  teal: "#14B8A6",
  amber: "#F97316",
};

export const seriesColors = [
  chartPalette.primary,
  chartPalette.success,
  chartPalette.warning,
  chartPalette.danger,
  chartPalette.info,
  chartPalette.purple,
  chartPalette.pink,
  chartPalette.teal,
  chartPalette.amber,
  chartPalette.primarySoft,
];

export const surfaceCardStyle = {
  background: "linear-gradient(180deg, #FFFFFF 0%, #FBFBFD 100%)",
  border: "1px solid rgba(15, 23, 42, 0.08)",
  borderRadius: 12,
  boxShadow:
    "0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 1px rgba(15, 23, 42, 0.02)",
};

export const surfaceCardHoverShadow =
  "0 8px 24px rgba(15, 23, 42, 0.06), 0 2px 6px rgba(15, 23, 42, 0.04)";
